import PropTypes from 'prop-types'
import React from 'react'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import styles from './ButtonGhost.scss'

export const ButtonGhost = props => (
    <button
        className={styles.base}
        onClick={props.onClick}
        onMouseDown={sendClickSoundCommand}
        onMouseEnter={sendHoverSoundCommand}
    >
        <span className={styles.caption}>{props.children}</span>
    </button>
)

ButtonGhost.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
}

export default ButtonGhost



// WEBPACK FOOTER //
// ./components/ButtonGhost/ButtonGhost.jsx